import * as React from "react";
import { SVGProps } from "react";
const SvgOpenFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m29.936 14.352-4.637 12a1.003 1.003 0 0 1-.934.649H2l4.763-12.702a2 2 0 0 1 1.873-1.298H29a1.002 1.002 0 0 1 .936 1.351ZM3 5h4.585l2.708 2.707c.188.187.442.293.707.293h14c.552 0 1 .449 1 1v2.001H8.634a3.999 3.999 0 0 0-3.745 2.596L2 21.304V6c0-.551.45-1 1-1Zm28.465 7.292A2.999 2.999 0 0 0 29 11.001h-1V9c0-1.654-1.346-3-3-3H11.415L8.707 3.293A1 1 0 0 0 8 3H3C1.345 3 0 4.346 0 6v21.001a2 2 0 0 0 2 2h22.364c1.244 0 2.36-.787 2.808-1.947l4.637-12a3.002 3.002 0 0 0-.344-2.762Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOpenFolder;
